"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdAccountBillingTypeToJSON = exports.AdAccountBillingTypeFromJSONTyped = exports.AdAccountBillingTypeFromJSON = exports.AdAccountBillingType = void 0;
/**
 * The billing type of the ad account.
 * @export
 */
exports.AdAccountBillingType = {
    UNSET: 'UNSET',
    INVOICE: 'INVOICE',
    PREPAY: 'PREPAY'
};
function AdAccountBillingTypeFromJSON(json) {
    return AdAccountBillingTypeFromJSONTyped(json, false);
}
exports.AdAccountBillingTypeFromJSON = AdAccountBillingTypeFromJSON;
function AdAccountBillingTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AdAccountBillingTypeFromJSONTyped = AdAccountBillingTypeFromJSONTyped;
function AdAccountBillingTypeToJSON(value) {
    return value;
}
exports.AdAccountBillingTypeToJSON = AdAccountBillingTypeToJSON;
